import edgeCommon from '../common';

let setting = (function () {
    let addValidations = function () {
        $("#setting-form").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                ram_size: { required: true, min: 2, step: 2 },
                cpu_size: { required: true, min: 2, step: 2 },
                price_per_gb: { required: true },
                primary_storage: { required: true },
                additional_storage_1: { required: true },
                additional_storage_2: { required: true },
                from_address: { email: true },
                to_mail: { email: true },
                registration_mail: { email: true },
                payment_mail: { email: true },
                infrastructure_mail: { email: true },
                price_per_strongbox: { required: true }
                
            },
        });

        $("#add-setting-form").click(function () {
            if ($("#setting-form").valid()) {
                Swal.fire({
                    title: "Are you sure?",
                    text: "You want to update current settings",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, Update it!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        $(".loading").removeClass("d-none");
                        let formData = new FormData($("#setting-form")[0]);
                        $.ajax({
                            url: baseUrl + "/admin/settings/store",
                            type: "POST",
                            data: formData,
                            async: false,
                            cache: false,
                            contentType: false,
                            processData: false,
                            success: function (response) {
                                $(".loading").addClass("d-none");
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            },
                        });
                    }
                });
            }
        });

        $("#beta-demo").click(function () {
            let isDemo = $(this).is(":checked") ? true : false;

            Swal.fire({
                title: "Are you sure?",
                text: "You want to update demo settings",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Update it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + "/admin/settings/demoSettingUpdate",
                        type: "POST",
                        data: { demo: isDemo },
                        datatype: "JSON",
                        success: function (response) {
                            edgeCommon.swalSuccess(response.message).then(() => {
                                window.location.reload();
                            });
                        },
                    });
                } else {
                    $(this).is(":checked") ? $(this).prop("checked", false) : $(this).prop("checked", true);
                }
            });
        });
    };

    let initListing = function () {
        addValidations();
    };

    return {
        // public functions
        init: function () {
            initListing();
        },
    };
})();

$(document).ready(function () {
    setting.init();
});
